import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import {
  DFP_MODULE_LABELS,
  DFP_MODULE_ORDER,
  DfpModulesState,
} from '@features/dashboard/performance/pages/dfp/services/dfp-modules.state';

/**
 * Estado vazio da aba Demonstrativos quando a pessoa desliga todos os módulos na barra "Mostrar" (card 3801, Victor
 * em 30/10/2026). Explica onde ligar, oferece cada módulo num clique e o atalho de voltar ao padrão.
 */
@Component({
  selector: 'app-dfp-modules-empty-state',
  standalone: true,
  template: `
    <section class="modules-empty" aria-labelledby="modules-empty-title">
      <span class="modules-empty__icon" aria-hidden="true"><i class="pi pi-table"></i></span>
      <h3 id="modules-empty-title" class="modules-empty__title">Nenhum demonstrativo na tela</h3>
      <p class="modules-empty__text">
        Escolha o que quer ver em Mostrar, ao lado das abas, ou ligue direto por aqui. A tela lembra
        a sua escolha neste navegador.
      </p>
      <div class="modules-empty__actions">
        @for (key of keys; track key) {
          <button type="button" class="modules-empty__pill" (click)="modules.toggle(key)">
            <i class="pi pi-plus" aria-hidden="true"></i>
            <span>{{ labels[key] }}</span>
          </button>
        }
      </div>
      <button type="button" class="modules-empty__reset" (click)="modules.restoreDefault()">
        Voltar ao padrão (DRE, Balanço e Pontos de destaque)
      </button>
    </section>
  `,
  styleUrls: ['./modules-empty-state.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class DfpModulesEmptyStateComponent {
  protected readonly modules = inject(DfpModulesState);
  protected readonly keys = DFP_MODULE_ORDER;
  protected readonly labels = DFP_MODULE_LABELS;
}
